// extracted by mini-css-extract-plugin
export default {"logo":"logo-_Yotf","pFormField":"p-form-field-c_BuL","skipLink":"skipLink-fhuG6"};